import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BonusPointsState } from '../../../../../redux/models/loyalty/bonus-points.state';
import {BackendService} from '../../../../../redux/services/backend.service';
import { isOn } from 'feature-toggle-service';
@Component({
  standalone: false,
  selector: 'app-loyalty-points-tile',
  templateUrl: './loyalty-points-tile.component.html',
  styleUrls: ['./loyalty-points-tile.component.scss']
})
export class LoyaltyPointsTileComponent implements OnInit {
  @Input() pointsState: BonusPointsState;
  @Input() agentNumber: any;

  @Output() loadPointsTrigger: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickByOrderGiftsTrigger: EventEmitter<void> = new EventEmitter<void>();
  loyaltyAmadeusPlusMe = $localize`:@@loyalty-points-tile.loyaltyAmadeusPlusMe:Amadeus+Me`;
  loyaltyPointsTileFullReportLinkString = $localize`:@@loyalty-enrollment-tile.loyaltyPointsTileFullReportLink:Full report`;
  loyaltyPointsTilePointsString = $localize`:@@loyalty-enrollment-tile.loyaltyPointsTilePoints:points`;
  loyaltyPointsTileUsedString = $localize`:@@loyalty-enrollment-tile.loyaltyPointsTileUsed:Used`;
  loyaltyPointsTileExpiredString = $localize`:@@loyalty-enrollment-tile.loyaltyPointsTileExpired:Expired`;
  membershipIdLabelString = $localize`:@@loyalty$-points-tile.membershipIdLabel:Your membership ID:`;
  pointsExpiryString = $localize`:@@loyalty-bonus-points.loyaltyPointsWillExpire:points will expire on`;
  gmtConstantString = $localize`:@@loyalty.loyaltyRequestTileAtGmt:at 23:59 (GMT)`;
  cronGenericFailureString = $localize`:@@loyalty.loyaltyCronFailed:Unable to retrieve. You can calculate them manually in the Status points section.`;
  readonly expiringConstantString = $localize`:@@loyalty-bonus-points.loyaltyPointsExpiring:Points expiring on`;

  xlinkString = '/assets/images/svg_ico/icons.svg#ic_external_link';

  enablePointBalanceBannerTile = isOn('AD_POINT_BALANCE_BANNER_E');
  lastDayOfMonth =new Date(new Date().getFullYear(), new Date().getMonth()+1, 0);
  expirationPointsEnabledForMarket= false;

  constructor(private readonly backendService: BackendService){}

  ngOnInit() {
    this.loadPointsTrigger.emit();
    this.backendService.getModularityConfig().subscribe( response => {
      this.expirationPointsEnabledForMarket= response?.loyalty?.enabled_for_monthly_expiration_points;
    });
  }

  handleClickByOrderGifts() {
    this.clickByOrderGiftsTrigger.emit();
  }
}
